import React from 'react';

export default function TermsOfService() {
  return (
    <div style={{ padding: '2rem', maxWidth: 800, margin: 'auto', fontFamily: 'sans-serif', lineHeight: 1.6 }}>
      <h1>Terms of Service</h1>

      <p>Welcome to PanAm Explorer. These Terms of Service ("Terms") govern your access to and use of the PanAm Explorer mobile app, website, and related services (collectively, the "Service") operated by PanAm Explorer ("we", "our", "us").</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By accessing or using the Service, you agree to be bound by these Terms and our <a href="/privacy-policy">Privacy Policy</a>. If you do not agree, you must not use the Service.</p>

      <h2>2. Eligibility</h2>
      <p>You must be at least 13 years old to use the Service. If you are under the age of majority in your jurisdiction, you must have your parent or guardian’s permission to use the Service.</p>

      <h2>3. Account Registration</h2>
      <p>To access certain features, you may be required to create an account. You must provide accurate and complete information and keep your account credentials secure. You are responsible for any activity that occurs under your account.</p>

      <h2>4. Use of the Service</h2>
      <p>The Service is provided for your personal, non-commercial use. You agree not to misuse the Service or help anyone else do so. Prohibited behavior includes but is not limited to:</p>
      <ul>
        <li>Posting false or misleading information</li>
        <li>Uploading offensive, harmful, or illegal content</li>
        <li>Harassing or threatening other users</li>
        <li>Violating the privacy or rights of others</li>
        <li>Interfering with or disrupting the Service</li>
      </ul>

      <h2>5. Content Submission</h2>
      <p>When you submit content (e.g., map pins, reviews, comments, profile data), you retain ownership of your content, but you grant us a non-exclusive, worldwide, royalty-free license to use, display, reproduce, and distribute your content in connection with the Service. You are responsible for ensuring your submissions comply with all applicable laws and these Terms.</p>

      <h2>6. Location Sharing</h2>
      <p>If you enable live or pinned location sharing, your location may be visible to other users on the map. You may disable location sharing at any time within the app settings.</p>

      <h2>7. Subscriptions & Payments</h2>
      <p>Some features may be offered as part of a paid subscription. By subscribing, you agree to the pricing, billing frequency, and other terms presented to you at the time of purchase. Payments are processed by third-party providers such as Google Play or Apple App Store and are subject to their terms.</p>

      <h2>8. Termination</h2>
      <p>We reserve the right to suspend or terminate your access to the Service at our discretion, with or without notice, for behavior that violates these Terms or is otherwise harmful to the community.</p>

      <h2>9. Disclaimers</h2>
      <p>The Service is provided “as is” and “as available.” We make no warranties, express or implied, regarding the availability, accuracy, or reliability of the Service. Use the Service at your own risk.</p>

      <h2>10. Limitation of Liability</h2>
      <p>To the maximum extent permitted by law, PanAm Explorer shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your use of or inability to use the Service.</p>

      <h2>11. Indemnification</h2>
      <p>You agree to indemnify and hold harmless PanAm Explorer and its affiliates, partners, and service providers from any claims, damages, or losses arising out of your use of the Service or your violation of these Terms.</p>

      <h2>12. Changes to the Terms</h2>
      <p>We may update these Terms at any time. If we make material changes, we will notify you via email or in-app notification. Continued use of the Service after such updates constitutes your acceptance of the new Terms.</p>

      <h2>13. Contact Us</h2>
      <p>If you have any questions about these Terms, please contact us at <a href="mailto:panamexplorer@gmail.com">panamexplorer@gmail.com</a>.</p>

      <hr />
      <small>© 2025 PanAm Explorer</small>
    </div>
  );
}
